// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3l-s5","containerItemsCenter":"Skeleton_containerItemsCenter__k0IpF"};